import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authFetch } from '../lib/authFetch';

// Handles the return leg of Emergent-managed Google sign-in.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = (location.hash || '').match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const finish = () => {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      navigate('/', { replace: true });
    };

    if (!sessionId) { finish(); return; }

    (async () => {
      try {
        const res = await authFetch('/api/auth/google/session', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error('Session exchange failed');
        await refreshUser();
        finish();
      } catch (e) {
        setError('Sign-in could not be completed. Please try again.');
        setTimeout(finish, 2500);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main
      data-testid="google-auth-callback"
      style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        background: '#0a0a0f', color: '#FFD700',
        fontFamily: "Georgia, 'Times New Roman', serif",
      }}
    >
      <div style={{
        width: 64, height: 64, borderRadius: '50%',
        border: '3px solid rgba(255,215,0,0.25)', borderTopColor: '#FFD700',
        animation: 'authSpin 0.9s linear infinite', marginBottom: '1.4rem',
      }} />
      <style>{'@keyframes authSpin { to { transform: rotate(360deg); } }'}</style>
      <h1 style={{ fontSize: '1.3rem', letterSpacing: '0.08em', margin: 0 }}>
        {error || 'Opening the gate…'}
      </h1>
      <p style={{ color: '#c9b06a', fontSize: 14, marginTop: 8 }}>
        {error ? 'Returning you home.' : 'Sealing your Google sign-in with the Federation.'}
      </p>
    </main>
  );
}
